import { DomainFieldConfig, FieldType } from "@/pages/documentCompile/type";
import { domainConfig } from "../config/sysConfig";

// const LockStraget = "contentLocked"
const LockStraget = "unlocked"

// 插入文本域
export const insertTextSdt = (
  connector: any,
  fieldConfig: DomainFieldConfig,
  value?: any
) => {
  console.log("insertTextSdt")
  window.Asc = window.Asc || {};
  window.Asc.scope = window.Asc.scope || {};
  window.Asc.scope.fieldConfig = fieldConfig;
  window.Asc.scope.domainConfig = domainConfig;
  window.Asc.scope.LockStraget = LockStraget
  window.Asc.scope.fieldValue = value
  // 生成一个唯一的命令 ID
  const commandId = `cmd_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
  // 核心：将本次命令 ID 传入 scope
  window.Asc.scope.currentCommandId = commandId;
  connector.callCommand(() => {
    console.log("insertTextSdtCall")
    // 1. 获取 scope 中的 ID
    const cmdId = Asc.scope.currentCommandId;
    // 2. 定义一个全局变量来存储已执行的 ID (挂载在 window 或 Asc 上)
    //  @ts-ignore
    if (!window._executedCommands) {
      //  @ts-ignore
      window._executedCommands = {};
    }

    // 3. 检查该 ID 是否已执行
    //  @ts-ignore
    if (window._executedCommands[cmdId]) {
      console.warn("Duplicate command blocked:", cmdId);
      return;
    }

    // 4. 标记为已执行
    //  @ts-ignore
    window._executedCommands[cmdId] = true;
    function generateRandomId() {
      let key = "";
      const data =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (let i = 0; i < 12; i++) {
        let index = Math.floor(Math.random() * data.length);
        key += data.charAt(index);
      }
      return key;
    }
    let doc = Api.GetDocument();
    const { fieldConfig, domainConfig, LockStraget, fieldValue } = Asc.scope;
    let paragraph = doc.GetCurrentParagraph(); // 获取当前光标所在的段落
    if (paragraph) {
      let cc = Api.CreateInlineLvlSdt();
      cc.SetBackgroundColor(255, 255, 0, 100); // 黄色
      cc.SetLock(LockStraget)
      // 用反引号包裹，避免出现@符号
      const randomId = generateRandomId();
      cc.SetTag(`${fieldConfig.fieldTag}@@${randomId}`);
      const alias = fieldConfig.fieldName ? `$${fieldConfig.fieldName}` : ''
      cc.SetAlias(alias)
      const text = fieldValue || alias
      cc.AddText(text)
      let section = paragraph.GetSection();
      console.log("section", section)
      paragraph.AddElement(cc);
      // paragraph.Push(cc);
      // doc.InsertContent([cc], true, { KeepTextOnly: true });
      // doc.InsertContent([cc], true, { KeepTextOnly: true });
      // paragraph.AddInlineLvlSdt(cc)
      // doc.InsertContent([cc], true, { KeepTextOnly: true });
    }
  });
};

// 插入复选框域
export const insertCheckboxSdt = (
  connector: any,
  fieldConfig: DomainFieldConfig,
  value?: any
) => {
  window.Asc = window.Asc || {};
  window.Asc.scope = window.Asc.scope || {};
  window.Asc.scope.fieldConfig = fieldConfig;
  window.Asc.scope.domainConfig = domainConfig;
  window.Asc.scope.LockStraget = LockStraget
  window.Asc.scope.fieldValue = value
  // 生成一个唯一的命令 ID
  const commandId = `cmd_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
  // 核心：将本次命令 ID 传入 scope
  window.Asc.scope.currentCommandId = commandId;
  connector.callCommand(() => {
    // 1. 获取 scope 中的 ID
    const cmdId = Asc.scope.currentCommandId;
    // 2. 定义一个全局变量来存储已执行的 ID (挂载在 window 或 Asc 上)
    //  @ts-ignore
    if (!window._executedCommands) {
      //  @ts-ignore
      window._executedCommands = {};
    }

    // 3. 检查该 ID 是否已执行
    //  @ts-ignore
    if (window._executedCommands[cmdId]) {
      console.warn("Duplicate command blocked:", cmdId);
      return;
    }

    // 4. 标记为已执行
    //  @ts-ignore
    window._executedCommands[cmdId] = true;
    let doc = Api.GetDocument();
    const { domainConfig, LockStraget, fieldValue } = Asc.scope;
    const fieldConfig = Asc.scope.fieldConfig as DomainFieldConfig
    function splitTemplateString(str: string) {
      const regex = /(\$\{[^}]+\})/g;
      return str.split(regex).filter((part) => part !== "");
    }
    function generateRandomId() {
      let key = "";
      const data =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (let i = 0; i < 12; i++) {
        let index = Math.floor(Math.random() * data.length);
        key += data.charAt(index);
      }
      return key;
    }
    // 根据id 获取字段域配置
    const getFieldConfigById = (id: string) => {
      return domainConfig
        .flatMap((item) => item.fields)
        .find((item) => item.id === id);
    };
    const getDomainElements = ({
      text,
      checkboxValue,
      docPid,
      docPtag,
    }: {
      text: string;
      checkboxValue?: any;
      docPid?: string;
      docPtag?: string;
    }) => {
      console.log("docPid", docPid);
      const elemens = [] as any[];
      const parts = splitTemplateString(text);
      parts.forEach((part, index) => {
        if (part.startsWith("${")) {
          const refFieldId = part.slice(2, -1);
          const refField = getFieldConfigById(refFieldId);
          if (refField) {
            const refControl = Api.CreateInlineLvlSdt();
            // 保持原来的tag，用于域的联动
            const refTag = docPtag?.replace(/@/g, "$");
            const randomId = generateRandomId();
            const tag = `${refField.id}@${refTag}@${randomId}@${index}`;
            refControl.SetTag(tag);
            const alias = refField.fieldName ? `$${refField.fieldName}` : ''
            refControl.SetAlias(alias)
            refControl.SetLock(LockStraget)
            // 设置特殊的id，包含复选框值信息，方便后续识别
            refControl.AddText(fieldValue || alias);
            refControl.SetBackgroundColor(255, 255, 0, 100);
            elemens.push(refControl);
          }
        } else {
          const run = Api.CreateRun();
          run.AddText(part);
          elemens.push(run);
        }
      });
      return elemens;
    };

    // 获取 contentSetting 和 content，处理空值
    const options = fieldConfig.content?.options || [];
    const isNewLine = fieldConfig.content?.isNewLine || false; // 默认不换行

    // 如果没有配置 content，则不创建复选框
    if (options.length === 0) {
      console.warn("No content configured for checkbox field:", fieldConfig.fieldTag);
      return;
    }

    let paragraph = doc.GetCurrentParagraph(); // 获取当前光标所在的段落
    if (!paragraph) {
      paragraph = Api.CreateParagraph();
      doc.Push(paragraph);
    }

    // 动态创建复选框
    options.forEach((item, index) => {
      let isChecked = fieldConfig.value?.includes(item.value);
      // 创建复选框
      let checkbox = Api.CreateCheckBoxContentControl({
        checked: isChecked,
        checkedSymbol: '9745',
        // checkedSymbol: "☒",        // 选中时显示 ☒
        // uncheckedSymbol: "☐"       // 未选中时显示 ☐
        // checkedSymbol: "✔",  // 选中时显示 ✔
        // uncheckedSymbol: "☐" // 未选中时显示 ☐
      });
      const randomId = generateRandomId();
      const tag = `${fieldConfig.fieldTag}@@${randomId}@@${index}`;
      checkbox.SetTag(tag);
      const alias = fieldConfig.fieldName ? `$${fieldConfig.fieldName}` : ''
      checkbox.SetAlias(alias)
      checkbox.SetLock(LockStraget)
      checkbox.OnContentChange = (event: any) => {
        console.log("OnContentChange", event);
      };
      checkbox.SetBackgroundColor(255, 255, 0, 100);
      // 创建标签元素，传递复选框值用于标记引用域
      const labelElements = getDomainElements({
        text: item.label,
        checkboxValue: item.value,
        docPtag: tag,
      });

      // 添加复选框元素
      paragraph.AddElement(checkbox);

      // 添加标签元素
      labelElements.forEach((element) => {
        paragraph.AddElement(element);
      });

      // 处理换行逻辑
      if (isNewLine && index < options.length - 1) {
        // 如果配置了换行且不是最后一个元素，则添加换行符
        paragraph.AddLineBreak();
      } else if (!isNewLine && index < options.length - 1) {
        // 如果没有配置换行且不是最后一个元素，则添加空格分隔
        paragraph.AddText(" ");
      }
    });

    console.log("Created checkboxes for content:", options);
  });
};

// 插入图片域
export const insertImageSdt = (
  connector: any,
  fieldConfig: DomainFieldConfig,
  value?: any
) => {
  window.Asc = window.Asc || {};
  window.Asc.scope = window.Asc.scope || {};
  window.Asc.scope.fieldConfig = fieldConfig;
  window.Asc.scope.LockStraget = LockStraget
  // 生成一个唯一的命令 ID
  const commandId = `cmd_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
  // 核心：将本次命令 ID 传入 scope
  window.Asc.scope.currentCommandId = commandId;

  connector.callCommand(() => {
    // 1. 获取 scope 中的 ID
    const cmdId = Asc.scope.currentCommandId;
    // 2. 定义一个全局变量来存储已执行的 ID (挂载在 window 或 Asc 上)
    //  @ts-ignore
    if (!window._executedCommands) {
      //  @ts-ignore
      window._executedCommands = {};
    }

    // 3. 检查该 ID 是否已执行
    //  @ts-ignore
    if (window._executedCommands[cmdId]) {
      console.warn("Duplicate command blocked:", cmdId);
      return;
    }

    // 4. 标记为已执行
    //  @ts-ignore
    window._executedCommands[cmdId] = true;
    function generateRandomId() {
      let key = "";
      const data =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (let i = 0; i < 12; i++) {
        let index = Math.floor(Math.random() * data.length);
        key += data.charAt(index);
      }
      return key;
    }
    let doc = Api.GetDocument();
    const fieldConfig = Asc.scope.fieldConfig as DomainFieldConfig
    const LockStraget = Asc.scope.LockStraget
    let paragraph = doc.GetCurrentParagraph(); // 获取当前光标所在的段落
    if (paragraph) {
      let cc = Api.CreatePictureContentControl(2000000, 2000000);
      cc.SetAppearance("hidden");
      cc.SetBackgroundColor(255, 255, 0, 100); // 黄色
      const randomId = generateRandomId();
      cc.SetTag(`${fieldConfig.fieldTag}@@${randomId}`);
      const alias = fieldConfig.fieldName ? `$${fieldConfig.fieldName}` : ''
      cc.SetAlias(alias)
      cc.SetLock(LockStraget)
      paragraph.AddElement(cc);
    }
  });
};

// 插入日期域
export const insertDateSdt = (
  connector: any,
  fieldConfig: DomainFieldConfig,
  value?: any
) => {
  window.Asc = window.Asc || {};
  window.Asc.scope = window.Asc.scope || {};
  window.Asc.scope.fieldConfig = fieldConfig;
  window.Asc.scope.FieldType = FieldType
  window.Asc.scope.LockStraget = LockStraget
  window.Asc.scope.fieldValue = value

  // 生成一个唯一的命令 ID
  const commandId = `cmd_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
  // 核心：将本次命令 ID 传入 scope
  // console.log("insertDateSdt", fieldConfig, value)
  window.Asc.scope.currentCommandId = commandId;
  connector.callCommand(() => {
    // 1. 获取 scope 中的 ID
    const cmdId = Asc.scope.currentCommandId;
    // 2. 定义一个全局变量来存储已执行的 ID (挂载在 window 或 Asc 上)
    //  @ts-ignore
    if (!window._executedCommands) {
      //  @ts-ignore
      window._executedCommands = {};
    }

    // 3. 检查该 ID 是否已执行
    //  @ts-ignore
    if (window._executedCommands[cmdId]) {
      console.warn("Duplicate command blocked:", cmdId);
      return;
    }

    // 4. 标记为已执行
    //  @ts-ignore
    window._executedCommands[cmdId] = true;
    function generateRandomId() {
      let key = "";
      const data =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (let i = 0; i < 12; i++) {
        let index = Math.floor(Math.random() * data.length);
        key += data.charAt(index);
      }
      return key;
    }
    let doc = Api.GetDocument();
    const fieldConfig = Asc.scope.fieldConfig as DomainFieldConfig
    const FieldType = Asc.scope.FieldType
    const LockStraget = Asc.scope.LockStraget
    const fieldValue = Asc.scope.fieldValue
    // console.log("insertDateSdt", { fieldConfig, FieldType, LockStraget, fieldValue })
    let paragraph = doc.GetCurrentParagraph(); // 获取当前光标所在的段落
    if (paragraph) {
      let dataFormat = 'yyyy.MM.dd'
      if (fieldConfig.fieldType === FieldType.DATE_SHORT) {
        dataFormat = 'yyyy.MM.dd'
      } else if (fieldConfig.fieldType === FieldType.DATE_LONG) {
        dataFormat = 'yyyy年MM月dd日'
      }
      let cc = Api.CreateDatePickerContentControl({ format: dataFormat });
      cc.SetBackgroundColor(255, 255, 0, 100); // 黄色
      const randomId = generateRandomId();
      cc.SetTag(`${fieldConfig.fieldTag}@@${randomId}`);
      const alias = fieldConfig.fieldName ? `$${fieldConfig.fieldName}` : ''
      cc.SetAlias(alias)
      cc.SetLock(LockStraget)
      const dateVuel = new Date(fieldValue)
      if (dateVuel) {
        cc.SetDate(dateVuel)
      }
      paragraph.Push(cc);
    }
  });
};

// 插入下拉域
export const insertDropdownSdt = (
  connector: any,
  fieldConfig: DomainFieldConfig,
  value?: any
) => {
  // const sdt = Api.CreateInlineLvlSdt();
  // sdt.SetTag(fieldConfig.fieldTag);
  // sdt.SetBackgroundColor(255, 255, 0);
  // const paragraph = Api.CreateParagraph();
  // paragraph.AddText(options.map((option) => option.label).join(", "));
  // sdt.AddElement(paragraph, 0);

  window.Asc = window.Asc || {};
  window.Asc.scope = window.Asc.scope || {};
  window.Asc.scope.fieldConfig = fieldConfig;
  window.Asc.scope.LockStraget = LockStraget
  // 生成一个唯一的命令 ID
  const commandId = `cmd_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
  // 核心：将本次命令 ID 传入 scope
  window.Asc.scope.currentCommandId = commandId;

  connector.callCommand(() => {
    // 1. 获取 scope 中的 ID
    const cmdId = Asc.scope.currentCommandId;
    // 2. 定义一个全局变量来存储已执行的 ID (挂载在 window 或 Asc 上)
    //  @ts-ignore
    if (!window._executedCommands) {
      //  @ts-ignore
      window._executedCommands = {};
    }

    // 3. 检查该 ID 是否已执行
    //  @ts-ignore
    if (window._executedCommands[cmdId]) {
      console.warn("Duplicate command blocked:", cmdId);
      return;
    }

    // 4. 标记为已执行
    //  @ts-ignore
    window._executedCommands[cmdId] = true;
    function generateRandomId() {
      let key = "";
      const data =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (let i = 0; i < 12; i++) {
        let index = Math.floor(Math.random() * data.length);
        key += data.charAt(index);
      }
      return key;
    }
    let doc = Api.GetDocument();
    const fieldConfig = Asc.scope.fieldConfig as DomainFieldConfig
    const LockStraget = Asc.scope.LockStraget
    const optionsData = fieldConfig.content?.options?.map((option) => ({
      display: option.label,
      value: option.value + '',
    }));
    console.log('optionsData', optionsData);
    let paragraph = doc.GetCurrentParagraph(); // 获取当前光标所在的段落
    if (paragraph) {
      // let inlineLvlSdt = Api.CreateInlineLvlSdt(); // 创建内联内容控件
      // let run = Api.CreateRun(); // 创建文本运行
      // run.AddText("This is an inline content control."); // 添加文本
      // inlineLvlSdt.AddElement(run, 0); // 将文本运行添加到内容控件
      // paragraph.AddInlineLvlSdt(inlineLvlSdt); // 将内容控件插入到当前段落的光标位置
      let cc = Api.CreateComboBoxContentControl(optionsData, -1);
      cc.SetBackgroundColor(255, 255, 0, 100); // 黄色
      const randomId = generateRandomId();
      cc.SetTag(`${fieldConfig.fieldTag}@@${randomId}`);
      const alias = fieldConfig.fieldName ? `$${fieldConfig.fieldName}` : ''
      cc.SetAlias(alias)
      cc.SetLock(LockStraget)
      paragraph.Push(cc);
    }

    // let contentControlList = cc.GetDropdownList();
    // contentControlList.Add("Venus", "planet2", 1);
    // let paragraph = doc.GetElement(0);
    // paragraph.Push(cc);
  });
};
